import RodoAgreementsWFFMDataExchange from '@/services/RodoAgreementsWFFMDataExchange'

export const AgreementsLogic = {
  data () {
    return {
      dx: { agreements: new RodoAgreementsWFFMDataExchange(this.form) },
      agreements: [],
    }
  },
  created () {
    this.agreements = this.dx.agreements.data
  },
}


// WEBPACK FOOTER //
// ./src/components/forms/logic/RodoAgreements.js